var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.519 17.143L22.394 30.268C22.2111 30.4515 21.9938 30.5972 21.7545 30.6965C21.5152 30.7959 21.2586 30.847 20.9995 30.847C20.7404 30.847 20.4838 30.7959 20.2445 30.6965C20.0052 30.5972 19.7879 30.4515 19.605 30.268L6.47998 17.143C6.11013 16.7731 5.90234 16.2715 5.90234 15.7485C5.90234 15.2254 6.11013 14.7238 6.47998 14.3539C6.84983 13.9841 7.35146 13.7763 7.87451 13.7763C8.39756 13.7763 8.89919 13.9841 9.26904 14.3539L21.0011 26.086L32.7333 14.3523C33.1031 13.9824 33.6047 13.7747 34.1278 13.7747C34.6508 13.7747 35.1525 13.9824 35.5223 14.3523C35.8922 14.7221 36.1 15.2238 36.1 15.7468C36.1 16.2699 35.8922 16.7715 35.5223 17.1414L35.519 17.143Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/CaretDown.68556281fa7b00cdd44a349b4cee02ab.svg";
export { ForwardRef as ReactComponent };